export enum ErknmAnalyticsColumnTypesEnum {
  SECONDARY = 'SECONDARY',
  DEFAULT = 'DEFAULT',
  PRIMARY = 'PRIMARY',
  WARNING = 'WARNING',
}
